@file:OptIn(InternalResourceApi::class)

package evoshift.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/evoshift.composeapp.generated.resources/"

@delegate:ResourceContentHash(-1_104_746_418)
public val Res.string.paywall_price_weekly_phrase: StringResource by lazy {
      StringResource("string:paywall_price_weekly_phrase", "paywall_price_weekly_phrase", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 217810, 55),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 309454, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 199053, 51),
      ))
    }

@delegate:ResourceContentHash(140_001_471)
public val Res.string.paywall_price_yearly_phrase: StringResource by lazy {
      StringResource("string:paywall_price_yearly_phrase", "paywall_price_yearly_phrase", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 217866, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 309522, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 199105, 51),
      ))
    }

@delegate:ResourceContentHash(-645_340_641)
public val Res.string.paywall_recommended: StringResource by lazy {
      StringResource("string:paywall_recommended", "paywall_recommended", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 217918, 63),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 309582, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 199157, 47),
      ))
    }

@delegate:ResourceContentHash(738_640_838)
public val Res.string.paywall_restore: StringResource by lazy {
      StringResource("string:paywall_restore", "paywall_restore", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 218086, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 309850, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 199301, 47),
      ))
    }

@delegate:ResourceContentHash(-103_522_906)
public val Res.string.paywall_restore_nothing: StringResource by lazy {
      StringResource("string:paywall_restore_nothing", "paywall_restore_nothing", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 217982, 103),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 309670, 179),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 199205, 95),
      ))
    }

@delegate:ResourceContentHash(984_291_874)
public val Res.string.paywall_retry: StringResource by lazy {
      StringResource("string:paywall_retry", "paywall_retry", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 218134, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 309918, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 199349, 33),
      ))
    }

@delegate:ResourceContentHash(-865_595_093)
public val Res.string.paywall_start_trial: StringResource by lazy {
      StringResource("string:paywall_start_trial", "paywall_start_trial", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 218180, 75),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 309984, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 199383, 51),
      ))
    }

@delegate:ResourceContentHash(-195_470_597)
public val Res.string.paywall_subscribe: StringResource by lazy {
      StringResource("string:paywall_subscribe", "paywall_subscribe", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 218256, 41),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 310068, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 199435, 37),
      ))
    }

@delegate:ResourceContentHash(-1_356_022_464)
public val Res.string.paywall_subtitle: StringResource by lazy {
      StringResource("string:paywall_subtitle", "paywall_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 218298, 152),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 310126, 236),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 199473, 144),
      ))
    }

@delegate:ResourceContentHash(325_173_285)
public val Res.string.paywall_terms: StringResource by lazy {
      StringResource("string:paywall_terms", "paywall_terms", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 218451, 173),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 310363, 293),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 199618, 141),
      ))
    }

@delegate:ResourceContentHash(636_877_901)
public val Res.string.paywall_title: StringResource by lazy {
      StringResource("string:paywall_title", "paywall_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 218625, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 310657, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 199760, 45),
      ))
    }

@delegate:ResourceContentHash(-2_115_272_248)
public val Res.string.paywall_trial_ended: StringResource by lazy {
      StringResource("string:paywall_trial_ended", "paywall_trial_ended", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 218671, 155),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 310703, 235),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 199806, 139),
      ))
    }

@delegate:ResourceContentHash(-2_006_395_472)
public val Res.string.paywall_trial_offer: StringResource by lazy {
      StringResource("string:paywall_trial_offer", "paywall_trial_offer", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 218827, 75),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 310939, 131),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 199946, 79),
      ))
    }

@delegate:ResourceContentHash(-24_213_759)
public val Res.string.paywall_trial_running: StringResource by lazy {
      StringResource("string:paywall_trial_running", "paywall_trial_running", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 218903, 73),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 311071, 121),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 200026, 65),
      ))
    }

@delegate:ResourceContentHash(-672_239_562)
public val Res.string.paywall_welcome_premium: StringResource by lazy {
      StringResource("string:paywall_welcome_premium", "paywall_welcome_premium", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 218977, 55),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 311193, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 200092, 59),
      ))
    }

@delegate:ResourceContentHash(1_526_181_073)
public val Res.string.permission_employee: StringResource by lazy {
      StringResource("string:permission_employee", "permission_employee", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 219033, 39),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 311261, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 200152, 39),
      ))
    }

@delegate:ResourceContentHash(218_298_152)
public val Res.string.permission_manager: StringResource by lazy {
      StringResource("string:permission_manager", "permission_manager", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 219142, 38),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 311430, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 200261, 38),
      ))
    }

@delegate:ResourceContentHash(-1_190_711_938)
public val Res.string.permission_manager_financial: StringResource by lazy {
      StringResource("string:permission_manager_financial", "permission_manager_financial", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 219073, 68),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 311313, 116),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 200192, 68),
      ))
    }

@delegate:ResourceContentHash(-1_349_650_211)
public val Res.string.permission_owner: StringResource by lazy {
      StringResource("string:permission_owner", "permission_owner", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 219181, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 311481, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 200300, 32),
      ))
    }

@delegate:ResourceContentHash(1_080_652_378)
public val Res.string.person_name_unavailable: StringResource by lazy {
      StringResource("string:person_name_unavailable", "person_name_unavailable", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 219222, 79),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 311526, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 200333, 67),
      ))
    }

@delegate:ResourceContentHash(-180_790_072)
public val Res.string.place_add: StringResource by lazy {
      StringResource("string:place_add", "place_add", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 219302, 25),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 311626, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 200401, 21),
      ))
    }

@delegate:ResourceContentHash(671_695_544)
public val Res.string.place_all: StringResource by lazy {
      StringResource("string:place_all", "place_all", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 219328, 41),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 311660, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 200423, 33),
      ))
    }

@delegate:ResourceContentHash(-539_053_960)
public val Res.string.place_new_label: StringResource by lazy {
      StringResource("string:place_new_label", "place_new_label", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 219370, 39),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 311702, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 200457, 35),
      ))
    }

@delegate:ResourceContentHash(-1_974_354_924)
public val Res.string.place_none: StringResource by lazy {
      StringResource("string:place_none", "place_none", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 219410, 82),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 311754, 110),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 200493, 62),
      ))
    }

@delegate:ResourceContentHash(1_601_765_842)
public val Res.string.place_recent: StringResource by lazy {
      StringResource("string:place_recent", "place_recent", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 219550, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 311934, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 200609, 44),
      ))
    }

@delegate:ResourceContentHash(1_284_285_012)
public val Res.string.place_recent_for: StringResource by lazy {
      StringResource("string:place_recent_for", "place_recent_for", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 219493, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 311865, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 200556, 52),
      ))
    }

@delegate:ResourceContentHash(1_704_073_326)
public val Res.string.place_remove: StringResource by lazy {
      StringResource("string:place_remove", "place_remove", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 219724, 28),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 312184, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 200767, 28),
      ))
    }

@delegate:ResourceContentHash(-1_049_180_568)
public val Res.string.place_remove_confirm: StringResource by lazy {
      StringResource("string:place_remove_confirm", "place_remove_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 219603, 120),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 312003, 180),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 200654, 112),
      ))
    }

@delegate:ResourceContentHash(1_499_059_376)
public val Res.string.place_rename: StringResource by lazy {
      StringResource("string:place_rename", "place_rename", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 219808, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 312308, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 200847, 28),
      ))
    }

@delegate:ResourceContentHash(11_800_281)
public val Res.string.place_rename_title: StringResource by lazy {
      StringResource("string:place_rename_title", "place_rename_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 219753, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 312229, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 200796, 50),
      ))
    }

@delegate:ResourceContentHash(-1_283_499_428)
public val Res.string.place_required: StringResource by lazy {
      StringResource("string:place_required", "place_required", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 219849, 58),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 312365, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 200876, 54),
      ))
    }

@delegate:ResourceContentHash(-529_305_816)
public val Res.string.plan_ended_banner_member: StringResource by lazy {
      StringResource("string:plan_ended_banner_member", "plan_ended_banner_member", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 219908, 120),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 312452, 188),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 200931, 116),
      ))
    }

@delegate:ResourceContentHash(-1_382_942_371)
public val Res.string.plan_ended_banner_owner: StringResource by lazy {
      StringResource("string:plan_ended_banner_owner", "plan_ended_banner_owner", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 220029, 167),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 312641, 251),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 201048, 155),
      ))
    }

@delegate:ResourceContentHash(-1_492_217_593)
public val Res.string.plan_limit_none: StringResource by lazy {
      StringResource("string:plan_limit_none", "plan_limit_none", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 220327, 131),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 313095, 227),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 201322, 123),
      ))
    }

@delegate:ResourceContentHash(-384_924_552)
public val Res.string.plan_limit_none_ask_owner: StringResource by lazy {
      StringResource("string:plan_limit_none_ask_owner", "plan_limit_none_ask_owner", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 220197, 129),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 312893, 201),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 201204, 117),
      ))
    }

@delegate:ResourceContentHash(-96_319_608)
public val Res.string.plan_limit_seats: StringResource by lazy {
      StringResource("string:plan_limit_seats", "plan_limit_seats", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 220626, 180),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 313570, 248),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 201605, 152),
      ))
    }

@delegate:ResourceContentHash(-1_019_780_810)
public val Res.string.plan_limit_seats_ask_owner: StringResource by lazy {
      StringResource("string:plan_limit_seats_ask_owner", "plan_limit_seats_ask_owner", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 220459, 166),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 313323, 246),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 201446, 158),
      ))
    }

@delegate:ResourceContentHash(584_827_947)
public val Res.string.plan_limit_see_plans: StringResource by lazy {
      StringResource("string:plan_limit_see_plans", "plan_limit_see_plans", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 220807, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 313819, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 201758, 40),
      ))
    }

@delegate:ResourceContentHash(347_367_441)
public val Res.string.plan_limit_title: StringResource by lazy {
      StringResource("string:plan_limit_title", "plan_limit_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 220852, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 313896, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 201799, 52),
      ))
    }

@delegate:ResourceContentHash(-1_744_695_058)
public val Res.string.plan_limit_workplaces: StringResource by lazy {
      StringResource("string:plan_limit_workplaces", "plan_limit_workplaces", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 220905, 73),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 313969, 105),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 201852, 93),
      ))
    }

@delegate:ResourceContentHash(-108_876_979)
public val Res.string.plan_none: StringResource by lazy {
      StringResource("string:plan_none", "plan_none", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 220979, 33),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 314075, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 201946, 29),
      ))
    }

@delegate:ResourceContentHash(-467_339_842)
public val Res.string.plan_premium: StringResource by lazy {
      StringResource("string:plan_premium", "plan_premium", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 221013, 32),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 314121, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 201976, 32),
      ))
    }

@delegate:ResourceContentHash(-1_206_167_228)
public val Res.string.plan_trial: StringResource by lazy {
      StringResource("string:plan_trial", "plan_trial", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 221046, 38),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 314154, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 202009, 34),
      ))
    }

@delegate:ResourceContentHash(-911_525_271)
public val Res.string.plan_unlimited: StringResource by lazy {
      StringResource("string:plan_unlimited", "plan_unlimited", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 221085, 38),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 314209, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 202044, 34),
      ))
    }

@delegate:ResourceContentHash(2_005_425_973)
public val Res.string.planned: StringResource by lazy {
      StringResource("string:planned", "planned", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 221124, 23),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 314264, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 202079, 27),
      ))
    }

@delegate:ResourceContentHash(-1_812_176_352)
public val Res.string.policies_add: StringResource by lazy {
      StringResource("string:policies_add", "policies_add", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 221203, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 314371, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 202158, 52),
      ))
    }

@delegate:ResourceContentHash(-475_153_161)
public val Res.string.policies_add_title: StringResource by lazy {
      StringResource("string:policies_add_title", "policies_add_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 221148, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 314292, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 202107, 50),
      ))
    }

@delegate:ResourceContentHash(-1_154_467_246)
public val Res.string.policies_confirm_action: StringResource by lazy {
      StringResource("string:policies_confirm_action", "policies_confirm_action", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 221260, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 314452, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 202211, 43),
      ))
    }

@delegate:ResourceContentHash(2_065_094_446)
public val Res.string.policies_confirm_statement: StringResource by lazy {
      StringResource("string:policies_confirm_statement", "policies_confirm_statement", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 221308, 106),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 314516, 142),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 202255, 86),
      ))
    }

@delegate:ResourceContentHash(1_605_487_864)
public val Res.string.policies_confirm_title: StringResource by lazy {
      StringResource("string:policies_confirm_title", "policies_confirm_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 221415, 66),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 314659, 94),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 202342, 50),
      ))
    }

@delegate:ResourceContentHash(890_996_431)
public val Res.string.policies_confirmed: StringResource by lazy {
      StringResource("string:policies_confirmed", "policies_confirmed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 221606, 74),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 314922, 122),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 202513, 78),
      ))
    }

@delegate:ResourceContentHash(2_031_034_196)
public val Res.string.policies_confirmed_on: StringResource by lazy {
      StringResource("string:policies_confirmed_on", "policies_confirmed_on", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 221482, 73),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 314754, 101),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 202393, 73),
      ))
    }

@delegate:ResourceContentHash(810_484_871)
public val Res.string.policies_confirmed_people: StringResource by lazy {
      StringResource("string:policies_confirmed_people", "policies_confirmed_people", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 221556, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 314856, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 202467, 45),
      ))
    }

@delegate:ResourceContentHash(1_666_516_925)
public val Res.string.policies_delete_confirm: StringResource by lazy {
      StringResource("string:policies_delete_confirm", "policies_delete_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 221681, 187),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 315045, 267),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 202592, 155),
      ))
    }

@delegate:ResourceContentHash(865_986_673)
public val Res.string.policies_delete_title: StringResource by lazy {
      StringResource("string:policies_delete_title", "policies_delete_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 221869, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 315313, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 202748, 49),
      ))
    }

@delegate:ResourceContentHash(1_099_396_040)
public val Res.string.policies_deleted: StringResource by lazy {
      StringResource("string:policies_deleted", "policies_deleted", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 221919, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 315387, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 202798, 44),
      ))
    }

@delegate:ResourceContentHash(-617_893_558)
public val Res.string.policies_drop: StringResource by lazy {
      StringResource("string:policies_drop", "policies_drop", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 221972, 81),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 315456, 125),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 202843, 65),
      ))
    }

@delegate:ResourceContentHash(-2_127_992_332)
public val Res.string.policies_empty: StringResource by lazy {
      StringResource("string:policies_empty", "policies_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 222054, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 315582, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 202909, 46),
      ))
    }

@delegate:ResourceContentHash(1_194_118_912)
public val Res.string.policies_intro: StringResource by lazy {
      StringResource("string:policies_intro", "policies_intro", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 222101, 198),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 315645, 370),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 202956, 198),
      ))
    }

@delegate:ResourceContentHash(-716_828_196)
public val Res.string.policies_nobody_pending: StringResource by lazy {
      StringResource("string:policies_nobody_pending", "policies_nobody_pending", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 222300, 59),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 316016, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 203155, 63),
      ))
    }

@delegate:ResourceContentHash(-660_351_517)
public val Res.string.policies_not_signature: StringResource by lazy {
      StringResource("string:policies_not_signature", "policies_not_signature", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 222360, 246),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 316088, 394),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 203219, 222),
      ))
    }

@delegate:ResourceContentHash(-1_742_691_027)
public val Res.string.policies_not_yet: StringResource by lazy {
      StringResource("string:policies_not_yet", "policies_not_yet", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 222607, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 316483, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 203442, 48),
      ))
    }

@delegate:ResourceContentHash(-1_056_652_036)
public val Res.string.policies_pending_people: StringResource by lazy {
      StringResource("string:policies_pending_people", "policies_pending_people", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 222664, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 316556, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 203491, 43),
      ))
    }

@delegate:ResourceContentHash(-423_918_841)
public val Res.string.policies_publish_action: StringResource by lazy {
      StringResource("string:policies_publish_action", "policies_publish_action", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 222712, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 316600, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 203535, 43),
      ))
    }

@delegate:ResourceContentHash(-1_183_767_567)
public val Res.string.policies_published: StringResource by lazy {
      StringResource("string:policies_published", "policies_published", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 222810, 118),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 316734, 182),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 203629, 94),
      ))
    }

@delegate:ResourceContentHash(-308_835_448)
public val Res.string.policies_published_on: StringResource by lazy {
      StringResource("string:policies_published_on", "policies_published_on", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 222756, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 316664, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 203579, 49),
      ))
    }

@delegate:ResourceContentHash(-2_123_261_075)
public val Res.string.policies_publishing: StringResource by lazy {
      StringResource("string:policies_publishing", "policies_publishing", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 222929, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 316917, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 203724, 47),
      ))
    }

@delegate:ResourceContentHash(1_090_477_791)
public val Res.string.policies_read_action: StringResource by lazy {
      StringResource("string:policies_read_action", "policies_read_action", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 222977, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 316977, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 203772, 48),
      ))
    }

@delegate:ResourceContentHash(589_932_950)
public val Res.string.policies_read_count: StringResource by lazy {
      StringResource("string:policies_read_count", "policies_read_count", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 223022, 63),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 317030, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 203821, 63),
      ))
    }

@delegate:ResourceContentHash(-391_802_650)
public val Res.string.policies_report_title: StringResource by lazy {
      StringResource("string:policies_report_title", "policies_report_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 223086, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 317106, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 203885, 49),
      ))
    }

@delegate:ResourceContentHash(-1_822_093_839)
public val Res.string.policies_title: StringResource by lazy {
      StringResource("string:policies_title", "policies_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 223177, 38),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 317217, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 203972, 34),
      ))
    }

@delegate:ResourceContentHash(956_633_937)
public val Res.string.policies_title_field: StringResource by lazy {
      StringResource("string:policies_title_field", "policies_title_field", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 223140, 36),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 317172, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 203935, 36),
      ))
    }

@delegate:ResourceContentHash(1_438_334_361)
public val Res.string.policies_who_confirmed: StringResource by lazy {
      StringResource("string:policies_who_confirmed", "policies_who_confirmed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 223216, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 317260, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 204007, 46),
      ))
    }

@delegate:ResourceContentHash(-1_121_465_969)
public val Res.string.pos_api_key: StringResource by lazy {
      StringResource("string:pos_api_key", "pos_api_key", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 223263, 39),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 317307, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 204054, 39),
      ))
    }

@delegate:ResourceContentHash(-1_996_775_599)
public val Res.string.pos_connect: StringResource by lazy {
      StringResource("string:pos_connect", "pos_connect", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 223369, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 317481, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 204160, 39),
      ))
    }

@delegate:ResourceContentHash(622_567_303)
public val Res.string.pos_connected: StringResource by lazy {
      StringResource("string:pos_connected", "pos_connected", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 223303, 65),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 317351, 129),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 204094, 65),
      ))
    }

@delegate:ResourceContentHash(1_743_929_477)
public val Res.string.pos_disconnect: StringResource by lazy {
      StringResource("string:pos_disconnect", "pos_disconnect", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 223669, 34),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 317917, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 204440, 38),
      ))
    }

@delegate:ResourceContentHash(1_502_197_900)
public val Res.string.pos_disconnect_confirm: StringResource by lazy {
      StringResource("string:pos_disconnect_confirm", "pos_disconnect_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 223413, 170),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 317537, 278),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 204200, 158),
      ))
    }

@delegate:ResourceContentHash(1_527_003_433)
public val Res.string.pos_disconnected: StringResource by lazy {
      StringResource("string:pos_disconnected", "pos_disconnected", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 223584, 84),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 317816, 100),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 204359, 80),
      ))
    }

@delegate:ResourceContentHash(-141_375_801)
public val Res.string.pos_error_key_invalid: StringResource by lazy {
      StringResource("string:pos_error_key_invalid", "pos_error_key_invalid", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 223704, 77),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 317968, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 204479, 85),
      ))
    }

@delegate:ResourceContentHash(304_976_284)
public val Res.string.pos_error_key_rejected: StringResource by lazy {
      StringResource("string:pos_error_key_rejected", "pos_error_key_rejected", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 223782, 126),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 318058, 186),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 204565, 142),
      ))
    }

@delegate:ResourceContentHash(-1_063_159_154)
public val Res.string.pos_error_no_merchant: StringResource by lazy {
      StringResource("string:pos_error_no_merchant", "pos_error_no_merchant", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 223909, 97),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 318245, 165),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 204708, 101),
      ))
    }

@delegate:ResourceContentHash(311_161_466)
public val Res.string.pos_error_not_connected: StringResource by lazy {
      StringResource("string:pos_error_not_connected", "pos_error_not_connected", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 224007, 67),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 318411, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 204810, 59),
      ))
    }

@delegate:ResourceContentHash(-1_880_754_064)
public val Res.string.pos_error_vat_invalid: StringResource by lazy {
      StringResource("string:pos_error_vat_invalid", "pos_error_vat_invalid", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 224075, 81),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 318507, 97),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 204870, 81),
      ))
    }

@delegate:ResourceContentHash(-67_449_257)
public val Res.string.pos_intro: StringResource by lazy {
      StringResource("string:pos_intro", "pos_intro", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 224157, 221),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 318605, 369),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 204952, 193),
      ))
    }

@delegate:ResourceContentHash(1_435_954_761)
public val Res.string.pos_last_sync: StringResource by lazy {
      StringResource("string:pos_last_sync", "pos_last_sync", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 224655, 41),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 319351, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 205406, 37),
      ))
    }

@delegate:ResourceContentHash(1_317_649_183)
public val Res.string.pos_last_sync_failed: StringResource by lazy {
      StringResource("string:pos_last_sync_failed", "pos_last_sync_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 224379, 120),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 318975, 172),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 205146, 108),
      ))
    }

@delegate:ResourceContentHash(-1_598_240_785)
public val Res.string.pos_last_sync_key: StringResource by lazy {
      StringResource("string:pos_last_sync_key", "pos_last_sync_key", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 224500, 109),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 319148, 153),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 205255, 105),
      ))
    }

@delegate:ResourceContentHash(-1_497_833_285)
public val Res.string.pos_last_sync_ok: StringResource by lazy {
      StringResource("string:pos_last_sync_ok", "pos_last_sync_ok", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 224610, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 319302, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 205361, 44),
      ))
    }

@delegate:ResourceContentHash(-1_056_652_036)
public val Res.string.pos_never: StringResource by lazy {
      StringResource("string:pos_never", "pos_never", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 224697, 33),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 319413, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 205444, 29),
      ))
    }

@delegate:ResourceContentHash(-1_619_840_205)
public val Res.string.pos_schedule: StringResource by lazy {
      StringResource("string:pos_schedule", "pos_schedule", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 224731, 92),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 319443, 124),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 205474, 96),
      ))
    }

@delegate:ResourceContentHash(-1_791_743_854)
public val Res.string.pos_status_connected: StringResource by lazy {
      StringResource("string:pos_status_connected", "pos_status_connected", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 224824, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 319568, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 205571, 60),
      ))
    }

@delegate:ResourceContentHash(-1_373_446_068)
public val Res.string.pos_steps: StringResource by lazy {
      StringResource("string:pos_steps", "pos_steps", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 224881, 361),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 319641, 501),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 205632, 337),
      ))
    }

@delegate:ResourceContentHash(1_965_418_250)
public val Res.string.pos_sync_now: StringResource by lazy {
      StringResource("string:pos_sync_now", "pos_sync_now", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 225243, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 320143, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 205970, 36),
      ))
    }

@delegate:ResourceContentHash(510_910_972)
public val Res.string.pos_synced: StringResource by lazy {
      StringResource("string:pos_synced", "pos_synced", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 225284, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 320208, 110),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 206007, 58),
      ))
    }

@delegate:ResourceContentHash(875_415_311)
public val Res.string.pos_title: StringResource by lazy {
      StringResource("string:pos_title", "pos_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 225347, 25),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 320319, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 206066, 37),
      ))
    }

@delegate:ResourceContentHash(188_206_937)
public val Res.string.pos_vat: StringResource by lazy {
      StringResource("string:pos_vat", "pos_vat", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 225507, 63),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 320567, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 206234, 51),
      ))
    }

@delegate:ResourceContentHash(1_017_488_825)
public val Res.string.pos_vat_hint: StringResource by lazy {
      StringResource("string:pos_vat_hint", "pos_vat_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 225373, 92),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 320353, 156),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 206104, 88),
      ))
    }

@delegate:ResourceContentHash(-900_399_431)
public val Res.string.pos_vat_used: StringResource by lazy {
      StringResource("string:pos_vat_used", "pos_vat_used", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 225466, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 320510, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 206193, 40),
      ))
    }

@delegate:ResourceContentHash(-1_496_078_034)
public val Res.string.posture_next_week: StringResource by lazy {
      StringResource("string:posture_next_week", "posture_next_week", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 225571, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 320659, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 206286, 37),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString27Resources(map: MutableMap<String, StringResource>) {
  map.put("paywall_price_weekly_phrase", Res.string.paywall_price_weekly_phrase)
  map.put("paywall_price_yearly_phrase", Res.string.paywall_price_yearly_phrase)
  map.put("paywall_recommended", Res.string.paywall_recommended)
  map.put("paywall_restore", Res.string.paywall_restore)
  map.put("paywall_restore_nothing", Res.string.paywall_restore_nothing)
  map.put("paywall_retry", Res.string.paywall_retry)
  map.put("paywall_start_trial", Res.string.paywall_start_trial)
  map.put("paywall_subscribe", Res.string.paywall_subscribe)
  map.put("paywall_subtitle", Res.string.paywall_subtitle)
  map.put("paywall_terms", Res.string.paywall_terms)
  map.put("paywall_title", Res.string.paywall_title)
  map.put("paywall_trial_ended", Res.string.paywall_trial_ended)
  map.put("paywall_trial_offer", Res.string.paywall_trial_offer)
  map.put("paywall_trial_running", Res.string.paywall_trial_running)
  map.put("paywall_welcome_premium", Res.string.paywall_welcome_premium)
  map.put("permission_employee", Res.string.permission_employee)
  map.put("permission_manager", Res.string.permission_manager)
  map.put("permission_manager_financial", Res.string.permission_manager_financial)
  map.put("permission_owner", Res.string.permission_owner)
  map.put("person_name_unavailable", Res.string.person_name_unavailable)
  map.put("place_add", Res.string.place_add)
  map.put("place_all", Res.string.place_all)
  map.put("place_new_label", Res.string.place_new_label)
  map.put("place_none", Res.string.place_none)
  map.put("place_recent", Res.string.place_recent)
  map.put("place_recent_for", Res.string.place_recent_for)
  map.put("place_remove", Res.string.place_remove)
  map.put("place_remove_confirm", Res.string.place_remove_confirm)
  map.put("place_rename", Res.string.place_rename)
  map.put("place_rename_title", Res.string.place_rename_title)
  map.put("place_required", Res.string.place_required)
  map.put("plan_ended_banner_member", Res.string.plan_ended_banner_member)
  map.put("plan_ended_banner_owner", Res.string.plan_ended_banner_owner)
  map.put("plan_limit_none", Res.string.plan_limit_none)
  map.put("plan_limit_none_ask_owner", Res.string.plan_limit_none_ask_owner)
  map.put("plan_limit_seats", Res.string.plan_limit_seats)
  map.put("plan_limit_seats_ask_owner", Res.string.plan_limit_seats_ask_owner)
  map.put("plan_limit_see_plans", Res.string.plan_limit_see_plans)
  map.put("plan_limit_title", Res.string.plan_limit_title)
  map.put("plan_limit_workplaces", Res.string.plan_limit_workplaces)
  map.put("plan_none", Res.string.plan_none)
  map.put("plan_premium", Res.string.plan_premium)
  map.put("plan_trial", Res.string.plan_trial)
  map.put("plan_unlimited", Res.string.plan_unlimited)
  map.put("planned", Res.string.planned)
  map.put("policies_add", Res.string.policies_add)
  map.put("policies_add_title", Res.string.policies_add_title)
  map.put("policies_confirm_action", Res.string.policies_confirm_action)
  map.put("policies_confirm_statement", Res.string.policies_confirm_statement)
  map.put("policies_confirm_title", Res.string.policies_confirm_title)
  map.put("policies_confirmed", Res.string.policies_confirmed)
  map.put("policies_confirmed_on", Res.string.policies_confirmed_on)
  map.put("policies_confirmed_people", Res.string.policies_confirmed_people)
  map.put("policies_delete_confirm", Res.string.policies_delete_confirm)
  map.put("policies_delete_title", Res.string.policies_delete_title)
  map.put("policies_deleted", Res.string.policies_deleted)
  map.put("policies_drop", Res.string.policies_drop)
  map.put("policies_empty", Res.string.policies_empty)
  map.put("policies_intro", Res.string.policies_intro)
  map.put("policies_nobody_pending", Res.string.policies_nobody_pending)
  map.put("policies_not_signature", Res.string.policies_not_signature)
  map.put("policies_not_yet", Res.string.policies_not_yet)
  map.put("policies_pending_people", Res.string.policies_pending_people)
  map.put("policies_publish_action", Res.string.policies_publish_action)
  map.put("policies_published", Res.string.policies_published)
  map.put("policies_published_on", Res.string.policies_published_on)
  map.put("policies_publishing", Res.string.policies_publishing)
  map.put("policies_read_action", Res.string.policies_read_action)
  map.put("policies_read_count", Res.string.policies_read_count)
  map.put("policies_report_title", Res.string.policies_report_title)
  map.put("policies_title", Res.string.policies_title)
  map.put("policies_title_field", Res.string.policies_title_field)
  map.put("policies_who_confirmed", Res.string.policies_who_confirmed)
  map.put("pos_api_key", Res.string.pos_api_key)
  map.put("pos_connect", Res.string.pos_connect)
  map.put("pos_connected", Res.string.pos_connected)
  map.put("pos_disconnect", Res.string.pos_disconnect)
  map.put("pos_disconnect_confirm", Res.string.pos_disconnect_confirm)
  map.put("pos_disconnected", Res.string.pos_disconnected)
  map.put("pos_error_key_invalid", Res.string.pos_error_key_invalid)
  map.put("pos_error_key_rejected", Res.string.pos_error_key_rejected)
  map.put("pos_error_no_merchant", Res.string.pos_error_no_merchant)
  map.put("pos_error_not_connected", Res.string.pos_error_not_connected)
  map.put("pos_error_vat_invalid", Res.string.pos_error_vat_invalid)
  map.put("pos_intro", Res.string.pos_intro)
  map.put("pos_last_sync", Res.string.pos_last_sync)
  map.put("pos_last_sync_failed", Res.string.pos_last_sync_failed)
  map.put("pos_last_sync_key", Res.string.pos_last_sync_key)
  map.put("pos_last_sync_ok", Res.string.pos_last_sync_ok)
  map.put("pos_never", Res.string.pos_never)
  map.put("pos_schedule", Res.string.pos_schedule)
  map.put("pos_status_connected", Res.string.pos_status_connected)
  map.put("pos_steps", Res.string.pos_steps)
  map.put("pos_sync_now", Res.string.pos_sync_now)
  map.put("pos_synced", Res.string.pos_synced)
  map.put("pos_title", Res.string.pos_title)
  map.put("pos_vat", Res.string.pos_vat)
  map.put("pos_vat_hint", Res.string.pos_vat_hint)
  map.put("pos_vat_used", Res.string.pos_vat_used)
  map.put("posture_next_week", Res.string.posture_next_week)
}
